export const COLORS = {
  primary: "#2f5241",
  hover: "#2f5241e1",
  border: "#dda248",
  background: "#fcf8ef",
  backgroundLight: "#fcf8ef83",
} as const;

export const SHED_STYLES = {
  GABLE: "gable",
  BARN: "barn",
  LEAN_TO: "lean-to",
} as const;

export type ShedStyle = (typeof SHED_STYLES)[keyof typeof SHED_STYLES];

export const DOOR_TYPES = {
  ROLL_UP: "roll-up",
  SINGLE: "single",
  DOUBLE: "double",
  HOUSE: "house",
} as const;

export const MATERIAL_TYPES = {
  METAL: "metal",
  SHINGLES: "shingles",
} as const;

export const SHINGLE_TYPES = {
  ARCHITECTURAL: "architectural",
  THREE_TAB: "3-tab",
} as const;

export const SHINGLE_COLORS = ["Black", "Brownwood", "Driftwood", "Gray"];

export const SHINGLE_BRANDS = [
  "GAF \u2013 Timberline HDZ",
  "Owens Corning \u2013 Duration Series",
  "CertainTeed \u2013 Landmark",
  "TAMKO \u2013 Heritage",
  "Atlas Pinnacle Pristine",
];

export const MODES = {
  SELECT: "select",
  CALIBRATE: "calibrate",
  MARK_CORNERS: "mark_corners",
} as const;

export type CalibrationMode = (typeof MODES)[keyof typeof MODES];

export interface Point {
  x: number;
  y: number;
}

export interface CalibrationPoints {
  tl: Point | null;
  tr: Point | null;
  br: Point | null;
  bl: Point | null;
}

export const INITIAL_CALIBRATION_POINTS: CalibrationPoints = {
  tl: null,
  tr: null,
  br: null,
  bl: null,
};

export interface ShedDimensions {
  width: number | "";
  length: number | "";
  wallHeight: number | "";
  totalHeight: number | "";
  fenceDistance: number | "";
  floorDistance: number | "";
  wallExteriorColor: string;
}

export const INITIAL_SHED_DIMENSIONS: ShedDimensions = {
  width: "",
  length: "",
  wallHeight: "",
  totalHeight: "",
  fenceDistance: "",
  floorDistance: "",
  wallExteriorColor: "",
};

export interface DoorState {
  selected: boolean;
  quantity: number;
  size?: string;
}

export interface ExtraState {
  selected: boolean;
  quantity: number;
  size?: string;
}

export interface ExtrasState {
  windows: ExtraState;
  vents: ExtraState;
}

export const INITIAL_EXTRAS: ExtrasState = {
  windows: { selected: false, quantity: 1, size: "" },
  vents: { selected: false, quantity: 1 },
};

export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;

export const MATERIALS_LIMITS = {
  maxChars: 510,
  maxLines: 14,
};
